import request from '@/utils/http'

const PREFIX = '/log/ck'

const ckLog = {
  listLogs(params) {
    return request(
      `${PREFIX}/list`,
      'post',
      params
    )
  },

  listConditionValue(params) {
    return request(
      `${PREFIX}/conditionValues`,
      'get',
      params
    )
  }
}

export default ckLog
